import remote, { setAuthCookie } from './remote';

export function facebookAuth(authToken) {
  return remote.login('auth/facebook', { auth_token: authToken });
}

export function pxcAuth(authToken) {
  return remote.login('oauth/1/authenticate', { auth_token: authToken });
}

export function portalAuth(authToken) {
  return remote.login('oauth/2/authenticate', { auth_token: authToken });
}

export function isLoggedIn() {
  return remote.isLoggedIn();
}

export function login(credentials) {
  return remote.login('auth', credentials);
}

export function logout() {
  return remote.logout('auth');
}

export function token() {
  return remote.token();
}

export function setToken(jwtToken) {
  return setAuthCookie(jwtToken);
}
